import { VehicleStatus } from '../..';

export interface IVehicle {
  id: string;
  countryId: string;
  registrationNumber: string;
  weightCapacity: string;
  dimensionalCapacity: string;
  make: string;
  model: string;
  status: VehicleStatus;
  isEntireCountry: boolean;
  isHeadOffice: boolean;
  name: string;
  usageType: string;
  type?: string;
}
